import type { Action } from '@reduxjs/toolkit';

export type ActionMeta = {
  createdAt: string;
  createdBy: string;
};

type TrackedEntity =
  | {
      updatedAt: string;
      updatedBy: string;
    }
  | {
      createdBy: string;
      createdAt: string;
    }
  | {
      createdBy: string;
      createdAt: string;
      updatedAt: string;
      updatedBy: string;
    };

function isTrackedAction(
  action: Action,
): action is { meta: ActionMeta; type: string } {
  return 'meta' in action;
}

export function assignMetadata<T extends TrackedEntity>(
  action: Action,
  target: T,
): T {
  if (!isTrackedAction(action)) {
    console.warn(
      'missing meta property from action, unable to assign metadata',
      {
        action: action.type,
      },
    );

    return target;
  }

  if ('createdAt' in target && !target.createdAt) {
    target.createdAt = action.meta.createdAt;
  }
  if ('createdBy' in target && !target.createdBy) {
    target.createdBy = action.meta.createdBy;
  }

  if ('updatedAt' in target) {
    target.updatedAt = action.meta.createdAt;
  }
  if ('updatedBy' in target) {
    target.updatedBy = action.meta.createdBy;
  }

  return target;
}
